
const saveToken = (token) => {
    localStorage.setItem('token', token);
}

const getToken = () => {
    return localStorage.getItem('token');
}

const saveInformation = (information) => {
    localStorage.setItem('information', JSON.stringify(information));
}

const getInformation = () => {
    return JSON.parse(localStorage.getItem('information'));
}

const isAuth = () => {
    return getToken() !== null;
}

const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('information');
}

const PatientLocalStorage = {
    saveToken,
    getToken,
    saveInformation,
    getInformation,
    isAuth,
    logout
}

export default PatientLocalStorage;